<template>
  <footer class="landing-footer">
    <div class="landing-container">
      <div class="landing-footer-grid">
        <!-- Branding and Description -->
        <div class="landing-footer-logo-col">
          <router-link to="/" class="landing-logo">
            <img :src="require('@/assets/sarpamp.png')" alt="SARPA MP Logo" class="landing-logo-img" />
            <span class="landing-logo-text">SARPA<span>MP</span></span>
          </router-link>
          <p class="landing-footer-desc">
            Snake Awareness, Rescue and Protection App
          </p>
          <div class="landing-socials">
            <a href="#" class="landing-social-link"><v-icon size="18" color="var(--text-muted)">mdi-facebook</v-icon></a>
            <a href="#" class="landing-social-link"><v-icon size="18" color="var(--text-muted)">mdi-instagram</v-icon></a>
            <a href="#" class="landing-social-link"><v-icon size="18" color="var(--text-muted)">mdi-youtube</v-icon></a>
          </div>
        </div>

        <!-- Links Column 1 -->
        <div>
          <h4 class="landing-footer-col-title">Quick Links</h4>
          <ul class="landing-footer-links">
            <li><router-link to="/" class="landing-footer-link">Home</router-link></li>
            <li><router-link to="/p/about-us" class="landing-footer-link">About Us</router-link></li>
            <li><router-link to="/p/mission-vision" class="landing-footer-link">Mission & Vision</router-link></li>
            <li><router-link to="/p/back-story" class="landing-footer-link">Back Story</router-link></li>
          </ul>
        </div>


        <!-- Links Column 2 -->
        <div>
          <h4 class="landing-footer-col-title">Legal</h4>
          <ul class="landing-footer-links">
            <li><router-link to="/p/privacy-policy" class="landing-footer-link">Privacy Policy</router-link></li>
            <li><router-link to="/p/terms-conditions" class="landing-footer-link">Terms & Conditions</router-link></li>
          </ul>
        </div>
        <!-- Call to Action -->
        <div class="d-flex flex-row flex-wrap align-center justify-start" style="gap: 12px;align-content: flex-start;">
          <!-- <a href="#" class="landing-btn" style="min-width: 140px;">
            <v-icon left size="18" color="white">mdi-apple</v-icon>
            App Store
          </a> -->

          <a href="https://play.google.com/store/apps/details?id=com.sarpamp.leopard&hl=en_IN" target="_blank" class="landing-btn" style="min-width: 140px;">
            <v-icon left size="18" color="white">mdi-google-play</v-icon>
            Play Store
          </a>
        </div>

      </div>

      <!-- Footer Bottom -->
      <div class="landing-footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} SARPA Madhya Pradesh. All rights reserved.</p>
        <p>Designed and Maintained by <span><a href="https://leopardtechlabs.com/" target="_blank">Leopard Tech Labs</a></span></p>
        <p>Developed in coordination with <span><a href="https://forest.mp.gov.in/" target="_blank">Madhya Pradesh Forest Department</a></span></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>
